import ManualVolumeTable from "./components/ManualVolumeTable";

const ManualFuelVolume = () => {
  return <ManualVolumeTable />;
};

export default ManualFuelVolume;
